import React, { Component } from 'react';
import './App.css';
import withAuth from './login/withAuth';
import HeaderContent from './main/Header';
import MainContent from './main/Main';
import FooterContent from './main/Footer';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <HeaderContent/>
        </header>
        <main>
          <MainContent />
        </main>
        <footer className="footer">
          <FooterContent/>
        </footer>
      </div>
    );
  }
}
  export default withAuth(App);
